module.exports = __webpack_public_path__ + "static/img/li8_4.2173d400.png";